<template>
  <div>
    <SearchableModel
      model-name="Registration"
      with-search
      :search-placeholder="$t('Search by name, email, company, phone number, or badge number')"
      :search-value="currentRegistration ? `${currentRegistration.firstname} ${currentRegistration.lastname}` : ''"
      with-qr-code-reader
      :with-export="withExport"
      :with-column-picker="withExport"
      queued-export
      :add-url="addUrl"
      :base-filters="baseFilters"
      :available-filters="availableFilters"
      :sort-options="sortOptions"
      :includes="['stages']"
      :enable-container="enableContainer"
      :push-state="pushState"
      :load-on-start
      :class="props.class"
    >
      <template v-if="$slots['header-title']" #header-title>
        <slot name="header-title"></slot>
      </template>

      <template v-if="$slots['header-actions']" #header-actions>
        <slot name="header-actions"></slot>
      </template>

      <template #default="{ models, search }">
        <div class="mx-auto table-responsive my-2">
          <table v-if="models" class="table table-hover">
            <thead class="tw:text-left tw:text-sm tw:bg-zinc-50 tw:hidden tw:md:table-header-group">
              <tr>
                <th>{{$t('Name')}}</th>
                <th>{{$t('Barcode')}}</th>
                <th>{{$t('Stages')}}</th>
                <th>{{$t('Tags')}}</th>
                <th class="tw:whitespace-nowrap">{{$t('Created at')}}</th>
                <th class="tw:whitespace-nowrap">{{$t('Tests count')}}</th>
                <th>{{$t('Status')}}</th>
              </tr>
            </thead>
            <tbody>
            <RegistrationIndexTableRow
              v-for="registration in models"
              v-bind:key="registration.id"
              :registration="registration"
              :search="search"
              :class="[registration.id === currentRegistration?.id ? 'table-primary': '']"
              :open-on-click="openOnClick"
              @registration-clicked="onClickRegistration(registration)"
            >
            </RegistrationIndexTableRow>
            </tbody>
          </table>
        </div>
      </template>
    </SearchableModel>
  </div>
</template>
<script setup lang="ts">
import type {  HTMLAttributes } from "vue";
import RegistrationIndexTableRow from './RegistrationIndexTableRow.vue';
import SearchableModel from "@/components/searchable-model/SearchableModel.vue";

const props = withDefaults(defineProps<{
  class? : HTMLAttributes["class"],
  addUrl: String,
  availableFilters: Array,
  baseFilters: Object,
  currentRegistration: Object,
  pushState: Boolean,
  withExport: boolean,
  enableContainer: Boolean,
  openOnClick : Boolean, // set to true to open registration link instead of event emit
}>(), {
  class: undefined,
  addUrl: null,
  availableFilters: () => [],
  baseFilters: () => ({}),
  currentRegistration: undefined,
  pushState: false,
  withExport: false,
  enableContainer: false,
  openOnClick: false,
});

const sortOptions = [
  {value: "name", label: "Name"},
  {value: "created_at", label: "Date"},
];

const emit = defineEmits(['change-registration']);

const onClickRegistration = (registration) => {
  emit('change-registration', registration);
}

</script>
